import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Card, CardBody} from 'reactstrap';
import FormButtons from 'components/FormButtons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as appActions from 'actions/appActions';
import { getFormValues, change } from 'redux-form';
import findIndex from 'lodash/findIndex';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import styles from './PreviewPage.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import evvntTicketingLogo from 'assets/images/evvnt_ticketing_wider.png';

class PreviewPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    saveDraft: PropTypes.func.isRequired,
    stepDetails: ImmutablePropTypes.map.isRequired,
    categories: PropTypes.array.isRequired,
    submissionForm: ImmutablePropTypes.map.isRequired,
    config: PropTypes.object.isRequired,
    showAppGlobalInfo: PropTypes.func.isRequired,
    hideAppGlobalInfo: PropTypes.func.isRequired,
    geotixVanityUrl: PropTypes.string.isRequired,
    quickFormActive: PropTypes.bool.isRequired,
    ticketingUrlType: PropTypes.string.isRequired,
    online: PropTypes.bool,
    discoveryPluginUrl: PropTypes.string.isRequired,
    isEventEligibleForOriginPub: PropTypes.bool.isRequired,
    originPublisherData: PropTypes.object,
    prepareDiscoveryPreview: PropTypes.func,
    have_premium_package: PropTypes.bool
  };

  state = {
    intervalId: null,
    renderedEventPreview: false
  }

  submitForm = () => this.props.submitForm('preview', this.props.history);
  saveDraft = () => this.props.saveDraft('preview');
  goToPreviousStep = () => this.props.goToPreviousStep('preview', this.props.history);
  editLink = () => {
    const toStep = this.props.quickFormActive ? 'quick' : 'basics';
    return(
      <Link className="btn btn-edit" to={this.props.stepDetails.getIn([toStep, 'path'])}>
        <i className="fa fa-edit"></i>Edit
      </Link>
    );
  }

  loadDiscoveryPlugin() {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.pollForReady();
    };
    script.src = this.props.discoveryPluginUrl;
    document.body.appendChild(script);
  }

  prepareDiscoveryEvent (){
    const { submissionForm } = this.props;
    let previewEvent = this.props.discoveryEvent;

    previewEvent.images = [];

    if (submissionForm.getIn(['data', 'images']).size === 0) {
      previewEvent.images.push({
        original: {
          url: previewEvent.stock_image_url,
          caption: 'Stock image'
        }
      });
    } else {
      submissionForm.getIn(['data', 'images']).forEach(image => (
        previewEvent.images.push({
          original: {
            id: image.get('id'),
            url: image.get('url'),
            caption: image.get('filename')
          }
        }))
      );
    }

    return previewEvent;
  }

  renderEventPreview() {
    const { isEventEligibleForOriginPub, originPublisherData } = this.props;
    const publisher_id = ( isEventEligibleForOriginPub && originPublisherData) ? originPublisherData.get('id') : 'evvnt.com';

    evvnt_require('evvnt/discovery_plugin').init({
      publisher_id: publisher_id,
      preview_event: this.prepareDiscoveryEvent(),
      discovery: {
        element: '#event-preview',
        detail_page_enabled: true,
        height: '100%',
        seo_optimize: false,
        map: false,
        widget: false
      }
    });
  }

  pollForReady() {
    const intervalId = setInterval(() => {
      if (this.props.discoveryEvent && typeof evvnt_require !== 'undefined' && !this.state.renderedEventPreview) {
        this.setState({ renderedEventPreview: true },function (){
          this.renderEventPreview();
        } );
        clearInterval(this.state.intervalId);
      }
    }, 500);

    this.setState({ intervalId: intervalId });
  }

  componentDidMount() {
    if (this.props.config.get('premium_edit')) {
      this.props.showAppGlobalInfo('Confirm your content edits and we\'ll make the changes across our network where possible.');
    }

    this.presetTicketsField();
    this.loadDiscoveryPlugin();
    this.props.prepareDiscoveryPreview();
  }

  componentWillUnmount() {
    if (this.props.config.get('premium_edit')) {
      this.props.hideAppGlobalInfo();
    }

    this.props.clearPreviewEvent();
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  presetTicketsField = () => {
    const index = findIndex(this.props.formValues.links, (link) => get(link, 'type.name', '') === 'Tickets');
    if (index > -1) {
      this.props.dispatch(change('eventSubmission', 'pricing_url', this.props.formValues.links[index].url));
    }

    const pricing_type = this.props.formValues.pricing_type;

    if (pricing_type === 'free') {
      this.props.dispatch(change('eventSubmission', 'prices', []));
    }

    const ticketsRequired = this.props.formValues.tickets_required;

    if (!ticketsRequired) {
      if (pricing_type === 'free')
        this.props.dispatch(change('eventSubmission', 'tickets_required', 'no'));
      else
        this.props.dispatch(change('eventSubmission', 'tickets_required', 'yes'));
    }
  }

  render() {
    const { config, ticketingUrlType, have_premium_package } = this.props;
    const isEvvntTicketed = ticketingUrlType === 'geotix';
    const nextBtnText = ((config.get('premium_edit') && have_premium_package) || config.get('recurring_event'))? 'Submit Edits' : 'Continue';

    return (
      <div>
        <FormButtons
          onNext={this.submitForm}
          onPrevious={this.goToPreviousStep}
          onSaveDraft={this.saveDraft}
          nextBtnText={nextBtnText}
        />
        <div className="row justify-content-center">
          <div className="col-md-10">
            {isEvvntTicketed && <div className={styles.ticketingBanner}>
              <img src={evvntTicketingLogo}/>
              <span>Thank you for selecting Evvnt Ticketing! Your ticketing page will be automatically created
                            in our software.
              </span>
            </div>}
            <Card className={styles.previewPage}>
              <CardBody>
                <div className="text-right">
                  {this.editLink()}
                </div>
                { !this.state.renderedEventPreview && <div className="loading-preview">
                  Generating preview...
                </div>}
                <div id="event-preview">
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('eventSubmission')(state),
  stepDetails: state.submissionForm.get('steps'),
  categories: state.categories,
  submissionForm: state.submissionForm,
  config: state.config,
  geotixVanityUrl: state.config.get('geotix_vanity_url'),
  quickFormActive: state.form.eventSubmission.values.quick_form,
  have_premium_package: state.config.get('have_premium_package'),
  online: state.form.eventSubmission.values.online,
  discoveryPluginUrl: state.config.get('discovery_plugin_url'),
  ticketingUrlType: state.form.eventSubmission.values.ticketing_url_type,
  discoveryEvent: state.submissionForm.get('steps').get('preview').get('discovery_event'),
  isEventEligibleForOriginPub: state.publishers.getIn(['eventEligibility', 'eligible']),
  originPublisherData: state.config.get('origin_publisher_data')
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(appActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/PreviewPage.jsx